import { tenantService } from "../../../../services/tenantService";
import LogoUploader, { S3Params } from "../../../../components/LogoUploader";
import React, { useEffect, useState } from "react";

interface SettingsTabProps {
  tenant: any;
  refetch: () => void;
}

const SettingsTab: React.FC<SettingsTabProps> = ({ tenant, refetch }) => {
    const [dataTobeUpdated, setDataTobeUpdated] = useState<{
        name: string;
        s3LogoObjectData: S3Params | null;
        s3FaviconObjectData: S3Params | null;
    }>({
        name: tenant?.name || "",
        s3LogoObjectData: tenant?.s3LogoObjectData,
        s3FaviconObjectData: tenant?.s3FaviconObjectData 
    });
    const [loading, setLoading] = useState(false);

  const update = async () => {
    try {
        setLoading(true);
        const res: any = await tenantService.update(tenant.id, dataTobeUpdated);
    } catch (err) {
        console.error("Failed to load tenant details", err);
    } finally {
        setLoading(false);
    }
    };

  useEffect(()=>{
    console.log("tenant in settings tab==>",tenant)
  },[tenant])

  return (
    <div className="space-y-10">

      {/* Header */}
      <h2 className="text-xl font-semibold">Tenant Settings</h2>

      {/* Tenant Name */}
      <div className="bg-gray-50 border rounded-xl p-6 flex flex-col gap-3">
        <label className="text-sm font-medium text-gray-700">Tenant Name</label>
        <input
          type="text"
          value={dataTobeUpdated.name}
          onChange={(e) => setDataTobeUpdated({ ...dataTobeUpdated, name: e.target.value })}
          placeholder="Enter tenant name"
          className="px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
        />
      </div>



      {/* FAVICON SECTION */}
      <div className="bg-white border rounded-xl p-6">
            <LogoUploader
                label="Upload Icon"
                value={dataTobeUpdated.s3LogoObjectData}
                onChange={(url) => {
                  setDataTobeUpdated({ ...dataTobeUpdated, s3LogoObjectData: url });
                }}
            />
      </div>
      <div className="bg-white border rounded-xl p-6">

            <LogoUploader
                label="Upload Favicon"
                value={dataTobeUpdated.s3FaviconObjectData}
                onChange={(url) => {
                  setDataTobeUpdated({ ...dataTobeUpdated, s3FaviconObjectData: url });
                }}
                />
      </div>

      {/* SAVE BUTTON */}
      <div className="flex justify-end pt-4">
        <button
          onClick={update}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default SettingsTab;
